export default {
  'component.instructional.title': 'Instruksjonsvideoer',
  'component.instructional.description':
    'Her finner du tips & råd til ulike steg i salgsprosessen, i tillegg til info om hvordan vår digitale løsning fungerer',
  'component.instructional.card.title': 'Richard Joy',
  'component.instructional.card.description':
    'Her kan du se filmer om både hvordan bruke vår digitale plattform',
};
